import { Box, Typography, TextField, Button, InputAdornment, Stack } from "@mui/material";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { ModelsTable } from "../components/ModelsTable";
import { CreateModelDialogue } from "../components/CreateModelDialogue";
import { useState, useRef } from "react";
import { useLocation } from "react-router";
import SearchBox from "../../../../../shell/components/SearchBox";
import { useTranslation } from "react-i18next";
export const AllModels = () => {
  const {
    t
  } = useTranslation();
  const [search, setSearch] = useState("");
  const location = useLocation();
  const triggerCreate = new URLSearchParams(location.search).get("triggerCreate");
  const [showCreateModelDialogue, setShowCreateModelDialogue] = useState(triggerCreate);
  const searchRef = useRef(null);
  return <>
      <Box width="100%" display="flex" flexDirection="column" sx={{
      backgroundColor: "grey.50"
    }} data-sentry-element="Box" data-sentry-source-file="AllModels.tsx">
        <Box display="flex" justifyContent="space-between" px={4} pt={4} pb={1.75} sx={{
        borderBottom: theme => `2px solid ${theme.palette.border}`,
        backgroundColor: "background.paper"
      }} data-sentry-element="Box" data-sentry-source-file="AllModels.tsx">
          <Typography variant="h3" fontWeight="700" data-sentry-element="Typography" data-sentry-source-file="AllModels.tsx">
            {t("schema.allModelsHeading")}
          </Typography>
          <Stack direction="row" alignItems="center" gap={1} data-sentry-element="Stack" data-sentry-source-file="AllModels.tsx">
            <SearchBox value={search} onChange={event => setSearch(event.target.value)} size="small" sx={{
            width: "240px",
            "& .MuiOutlinedInput-notchedOutline": {
              border: 0
            }
          }} inputRef={searchRef} InputProps={{
            sx: {
              backgroundColor: "grey.50"
            },
            startAdornment: <InputAdornment position="start" sx={{
              marginRight: 0.5
            }}>
                    <SearchRoundedIcon fontSize="small" color="action" />
                  </InputAdornment>
          }} placeholder={t("schema.searchModelsPlaceholder")} data-sentry-element="SearchBox" data-sentry-source-file="AllModels.tsx" />
            <Button variant="contained" size="small" startIcon={<AddRoundedIcon />} onClick={() => setShowCreateModelDialogue("true")} data-cy="create-model-button-all-models" data-sentry-element="Button" data-sentry-source-file="AllModels.tsx">
              {t("schema.createModel")}
            </Button>
          </Stack>
        </Box>
        <Box height="100%" px={4} pt={2} data-sentry-element="Box" data-sentry-source-file="AllModels.tsx">
          <ModelsTable search={search} onEmptySearch={() => {
          setSearch("");
          searchRef?.current?.focus();
        }} data-sentry-element="ModelsTable" data-sentry-source-file="AllModels.tsx" />
        </Box>
      </Box>
      {!!showCreateModelDialogue && <CreateModelDialogue modelType={showCreateModelDialogue !== "true" ? showCreateModelDialogue : undefined} onClose={() => setShowCreateModelDialogue("")} />}
    </>;
};